export const secureRoutesNames = {
  DISPENSARY: 'dispensary',
  BANK: 'bank',
  GCV: 'gcv',
  REGISTRATION: 'registration',
};
